import { Dispatch } from "redux";
import {
    setEmailError,
    setNewEmailError,
    setConfirmEmailError,
    setNewEmailSuccess,
    setConfirmEmailSuccess,
} from "../EditEmployeeModalSlice";

interface EmailState {
    newEmailAddress: string;
    confirmEmailAddress: string;
    emailError: string | null;
}

/**
 * Validates the email state and dispatches actions to update the Redux store
 * @param emailState The current email state
 * @param dispatch The Redux dispatch function
 */
export const validateEmailState = (
    emailState: EmailState,
    dispatch: Dispatch,
): void => {
    // Default state - reset success states
    dispatch(setNewEmailSuccess(false));
    dispatch(setConfirmEmailSuccess(false));

    // Clear error when user updates email
    if (emailState.emailError) {
        dispatch(setEmailError(null));
    }

    // When emails match exactly and are not empty
    const emailsMatchAndNotEmpty =
        emailState.newEmailAddress === emailState.confirmEmailAddress &&
        emailState.newEmailAddress !== "";
    if (emailsMatchAndNotEmpty) {
        // Reset error states
        dispatch(setNewEmailError(false));
        dispatch(setConfirmEmailError(false));
        // Set success states
        dispatch(setNewEmailSuccess(true));
        dispatch(setConfirmEmailSuccess(true));
        return;
    }

    // When confirmation email is not empty and doesn't match
    const confirmEmailNotEmptyAndMismatch =
        emailState.confirmEmailAddress !== "" &&
        emailState.newEmailAddress !== emailState.confirmEmailAddress;
    if (confirmEmailNotEmptyAndMismatch) {
        // Set error states
        dispatch(setNewEmailError(true));
        dispatch(setConfirmEmailError(true));
    }
};
